import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const DeviceListConnectPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    
    return (
        <div className="flex items-center translate-y-52 justify-center my-auto">
            <div className="text-center">
                <h2 className="text-2xl text-black font-semibold mb-2">
                    {t('device_list.no_device_connted')}
                </h2>
                <p className="whitespace-pre-line text-black text-base font-medium">
                {t('device_list.sub_title1')}<br />
                {t('device_list.sub_title2')}<br />
                {t('device_list.sub_title3')}
                </p>
            </div>
      </div>

    );
};
export default DeviceListConnectPage;